document.querySelectorAll( '.b-subsidiary' ).forEach( ( block ) => {

	const buttons = block.querySelectorAll( '.wp-block-button' );
	const content = block.querySelector( '.b-subsidiary__content' );

	buttons.forEach( button => {

		button.addEventListener( 'click', () => {

			if ( content ) {

				content.classList.toggle( 'b-subsidiary__content--active' );
				content.style.maxHeight = content.style.maxHeight ? null : `${content.scrollHeight}px`;

				buttons.forEach( currentButton => {

					currentButton.classList.toggle( 'wp-block-button--active' );

				} );

			}

		} )

	} );

} );

/**
 * Debounce
 *
 * @param {function} callback
 * @param {integer} delay
 * @return {(function(...[*]): void)|*}
 */
const debounce = ( callback, delay ) => {

	let timeout;
	return function executedFunction( ...args ) {

		/** */
		const later = () => {

			clearTimeout( timeout );
			callback( ...args );

		};
		clearTimeout( timeout );
		timeout = setTimeout( later, delay );

	};

}

/**
 * Recalculate Open Accordions
 */
const recalculateOpenAccordions = () => {

	document.querySelectorAll( '.b-subsidiary__content.active' ).forEach( contentActive => {

		contentActive.style.maxHeight = `${contentActive.scrollHeight}px`;

	} );

};
const debounceRecalculateAccordion = debounce( recalculateOpenAccordions, 50 );
window.addEventListener( 'resize', debounceRecalculateAccordion );